// extracted by mini-css-extract-plugin
module.exports = {"myIcon":"Icon_myIcon__3Ah8T","center":"Icon_center__1KHBP","circle":"Icon_circle__24oUa"};